"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContactActions = require("./ContactActions");
Object.keys(_ContactActions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactActions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactActions[key];
    }
  });
});